import { SideMenuI } from '../../../shared/interfaces/side-menu.interface';

export const SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Products',
    route: 'products',
    translationPath: 'sideMenu.products',
    activeIcon: 'svgs/side-menu/active-products.svg',
    inactiveIcon: 'svgs/side-menu/inactive-products.svg',
    roles: [],
  },
  {
    title: 'Working Hours',
    route: 'working-hours',
    translationPath: 'sideMenu.workingHours',
    activeIcon: 'svgs/side-menu/active-working-hours.svg',
    inactiveIcon: 'svgs/side-menu/inactive-working-hours.svg',
    roles: [],
  },
  {
    title: 'Orders',
    route: 'orders',
    translationPath: 'sideMenu.orders',
    activeIcon: 'svgs/side-menu/active-orders.svg',
    inactiveIcon: 'svgs/side-menu/inactive-orders.svg',
    roles: [],
  },
  {
    title: 'Commissions',
    route: 'commissions',
    translationPath: 'sideMenu.commissions',
    activeIcon: 'svgs/side-menu/active-commission.svg',
    inactiveIcon: 'svgs/side-menu/inactive-commission.svg',
    roles: [],
  },
  {
    title: 'Finance Management',
    route: 'finance-management',
    translationPath: 'sideMenu.financeManagement',
    activeIcon: 'svgs/side-menu/active-finance-management.svg',
    inactiveIcon: 'svgs/side-menu/inactive-finance-management.svg',
    roles: [],
  },
];
